import React from "react";
import BackButtonIcon from "../assets/back_button_icon.png";
import { Link } from "react-router-dom";

const BackButton = ({ onClickHandler = () => {}}) => {
  return (
    <div className="back-btn-container">
      <div className="back-btn-corner"></div>
      <Link
        className="text-decoration-none back-btn isuzu-btn isuzu-btn-shape"
        onClick={onClickHandler}
      >
        <img src={BackButtonIcon} className="back-btn-icon" />
      </Link>
    </div>
  );
};

export default BackButton;
